export default "__VITE_ASSET__BTyBUIlW__"